import React, { Component, Fragment } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router-dom'
import { getStringByTextKey } from '@/utils/getStringByTextKey'
import StepBarComponent from '@/components/Console/StepBar'
import './Navbar.scss'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import { getLanguage, localStrings } from '@/utils/localization'
import SwitchSelector from 'react-switch-selector'
import moment from 'moment'

@inject('store')
@observer
export default class NavbarConsoleComponent extends Component {
  commonStore = this.props.store.commonStore

  goMyAccount = () => {
    const lang = getLanguage()
    window.location.href = `${process.env.PUBLIC_URL}/${lang}/my-account`
  }

  render() {
    const {
      logout,
      path,
      goConsole,
      goBill,
      toggleContact,
      toggleContactOn,
      toggleUserMenu,
      toggleUserMenuOn,
      setWrapperRef,
      noticeText,
      closeNoticeToday,
      closeNotice,
      step,
      product,
      handleChangeForDropdown,
      isRenew
    } = this.props
    const { userInfo, navStep, hasSite, hasBill } = this.commonStore
    const options = [
      {
        label: (
          <div className="navbar-icon wrapsody">
            <i className="icon_wrapsody" />
          </div>
        ),
        value: 'WRAPSODY',
        selectedBackgroundColor: '#FFFFFF'
      },
      {
        label: (
          <div className="navbar-icon eco">
            <i className="icon_eco" />
          </div>
        ),
        value: 'WRAPSODY_ECO',
        selectedBackgroundColor: '#FFFFFF'
      }
    ]
    const initialSelectedIndex = options.findIndex(
      ({ value }) => value === product
    )
    const onChange = newValue => {
      handleChangeForDropdown('product', newValue)
    }
    const lang = getLanguage()
    return (
      <Fragment>
        <div
          className={`topDiv ${
            navStep > 1 &&
            hasSite !== 'true' &&
            path !== 'bill' &&
            path !== 'my-account' &&
            !isRenew
              ? noticeText
                ? 'topDiv_notice_navStep'
                : 'topDiv_navStep'
              : noticeText
              ? 'topDiv_notice'
              : 'topDiv_none'
          }`}
        >
          {noticeText ? (
            <div className="mainNoticeBox">
              <div>{noticeText}</div>
              <div className="closeText">
                <span onClick={() => closeNoticeToday()}>
                  {getStringByTextKey('navBar.notifications.close')}
                </span>
              </div>
              <div className="closeButton">
                <a onClick={() => closeNotice()}>
                  <i className="image" />
                </a>
              </div>
            </div>
          ) : (
            ''
          )}
          {path === 'new' ? (
            ''
          ) : (
            <div
              className={`${
                noticeText ? 'navbar_notice' : 'navbar_non-notice'
              }`}
            >
              <header id="navbar" className="navbar_header">
                <div className="icon_fasoo" onClick={goConsole}>
                  <Link to={`/${lang}/console`}></Link>
                </div>
                <div className={'navbar_switch'}>
                  <SwitchSelector
                    onChange={onChange}
                    style={{ width: 'fit-content' }}
                    options={options}
                    initialSelectedIndex={initialSelectedIndex}
                    forcedSelectedIndex={initialSelectedIndex}
                    backgroundColor={'#DFE3EB'}
                  />
                </div>

                <div ref={setWrapperRef} className="subMenu">
                  <div className="menu inline-block vertical-middle">
                    <a onClick={() => toggleContact()}>
                      <i className="icon_circle_question" />
                    </a>
                    <div
                      className={`contact_center ${
                        toggleContactOn ? 'on' : ''
                      }`}
                    >
                      <a
                        href={`${
                          product === 'WRAPSODY'
                            ? `https://www.wrapsody.com/${
                                localStrings.getLanguage() === 'ko'
                                  ? 'kr'
                                  : 'en'
                              }/inquiry/`
                            : `https://www.wrapsodyeco.com/${
                                localStrings.getLanguage() === 'ko'
                                  ? 'kr'
                                  : 'en'
                              }/inquiry/`
                        }`}
                        target="_blank"
                      >
                        <li className="menu_list">
                          {getStringByTextKey('navBar.contact.QnA')}
                        </li>
                      </a>
                      <a
                        href={`${
                          product === 'WRAPSODY'
                            ? `https://www.wrapsody.com/${
                                localStrings.getLanguage() === 'ko'
                                  ? 'kr'
                                  : 'en'
                              }/pricing/#FAQ`
                            : localStrings.getLanguage() === 'ko'
                            ? 'https://www.wrapsodyeco.com/kr/price/#FAQ'
                            : 'https://www.wrapsodyeco.com/en/plans-and-pricing/#FAQ'
                        }`}
                        target="_blank"
                      >
                        <li className="menu_list">
                          {getStringByTextKey('navBar.contact.FAQ')}
                        </li>
                      </a>
                    </div>
                  </div>
                  <div className="inline-block vertical-middle cursor-pointer">
                    <a onClick={() => toggleUserMenu()}>
                      <div className="userInfo inline-block vertical-middle">
                        {userInfo.userInfo.userName.substr(0, 2)}
                      </div>
                    </a>
                  </div>
                  <div
                    ref={setWrapperRef}
                    className="userInfoMore cursor-pointer"
                  >
                    <a onClick={() => toggleUserMenu()}>
                      <i className="icon_user_info" />
                    </a>
                    <div
                      className={`userInfoMore_center ${
                        toggleUserMenuOn ? 'on' : ''
                      }`}
                    >
                      <div className="menu_list">
                        <div className="userInfoMore__profile">
                          {userInfo.userInfo.userName.substr(0, 2)}
                        </div>
                        <div className="userInfoMore__info">
                          <span
                            className="userInfoMore__name"
                            title={userInfo.userInfo.userName}
                          >
                            {userInfo.userInfo.userName}
                          </span>
                          <span
                            className="userInfoMore__email"
                            title={userInfo.userInfo.userId}
                          >
                            {userInfo.userInfo.userId}
                          </span>
                        </div>
                      </div>
                      <div className="menu_list1" onClick={this.goMyAccount}>
                        {getStringByTextKey('navBar.myAccount.fieldname')}
                      </div>
                      <hr className="divider mg my-10" />
                      <div className="menu_list1" onClick={logout}>
                        <span className="text text--green">
                          {getStringByTextKey('navBar.myAccount.logout')}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
              {navStep > 1 &&
                hasSite !== 'true' &&
                path !== 'bill' &&
                path !== 'my-account' &&
                !isRenew && (
                  <div
                    className={`topStepBar ${
                      noticeText ? 'topStepBar_notice' : 'topStepBar_none'
                    }`}
                  >
                    <StepBarComponent step={navStep} />
                  </div>
                )}
            </div>
          )}
          {((path === 'console' && navStep !== 1 && navStep !== 2) ||
            path === 'bill') && (
            <nav
              className={`leftNav ${
                navStep > 1 &&
                hasSite !== 'true' &&
                path !== 'bill' &&
                path !== 'my-account' &&
                !isRenew
                  ? noticeText
                    ? 'leftNav_notice_navStep'
                    : 'leftNav_navStep'
                  : noticeText
                  ? 'leftNav_notice'
                  : 'leftNav_none'
              }`}
            >
              <ul className="leftNav-menu">
                <li
                  className={`site_mgnt ${path === 'console' ? 'active' : ''}`}
                >
                  <a onClick={goConsole}>
                    {getStringByTextKey('navBar.leftMenu.siteManagement')}
                  </a>
                </li>
                <li
                  className={`bill_history ${path === 'bill' ? 'active' : ''}`}
                >
                  <a onClick={goBill}>
                    {getStringByTextKey('navBar.leftMenu.paymentHistory')}
                  </a>
                </li>
              </ul>

              <p className="leftBottom">
                <span className="companyName">
                  {'© Fasoo'}
                  {/* {'© ' + moment().format('YYYY') + ' Fasoo'} */}
                  {/* {getStringByTextKey('navBar.companyName')} */}
                </span>
              </p>
            </nav>
          )}
          {path === 'my-account' && (
            <nav
              className={`leftNav ${
                navStep > 1 &&
                hasSite !== 'true' &&
                path !== 'bill' &&
                path !== 'my-account' &&
                !isRenew
                  ? noticeText
                    ? 'leftNav_notice_navStep'
                    : 'leftNav_navStep'
                  : noticeText
                  ? 'leftNav_notice'
                  : 'leftNav_none'
              }`}
            >
              <ul className="leftNav-menu">
                <li
                  className={`site_mgnt ${path === 'console' ? 'active' : ''}`}
                >
                  <a onClick={this.goMyAccount}>
                    {getStringByTextKey('navBar.myAccount.fieldname')}
                  </a>
                </li>
              </ul>

              <p className="leftBottom">
                <span className="companyName">
                  {'© Fasoo'}
                  {/* {'© ' + moment().format('YYYY') + ' Fasoo'} */}
                  {/* {getStringByTextKey('navBar.companyName')} */}
                </span>
              </p>
            </nav>
          )}
        </div>
        <div
          className={`topMargin ${
            navStep > 1 &&
            hasSite !== 'true' &&
            path !== 'bill' &&
            path !== 'my-account' &&
            !isRenew
              ? noticeText
                ? 'topMargin_notice_navStep'
                : 'topMargin_navStep'
              : noticeText
              ? 'topMargin_notice'
              : 'topMargin_none'
          }`}
        ></div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Console/Navbar/index.js